import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import data from '../../../../config/province.json';
import { Grid } from '@mui/material';

const textWidth = { maxWidth: '400px' };
const titleStyle = { textAlign: 'center' };
export default function SelectProvince() {
  const [province, setProvince] = React.useState('');

  const handleChangeProvince = (event) => {
    setProvince(event.target.value);
  };

  const renderOption = data.provinces.map((item, i) => {
    return (
      <MenuItem value={item.id} key={i}>{item.province}</MenuItem>
    );
  });

  return (
    <Grid container justifyContent="center" >
      <Grid item xs={12} sx={titleStyle}>
        <FormControl sx={textWidth} fullWidth>
          <InputLabel id="demo-simple-select-helper-label">Province/City</InputLabel>
          <Select
            fullWidth
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={province}
            label="Province/City"
            onChange={handleChangeProvince}
            variant="outlined"
            sx={textWidth}
          >
            {renderOption}
          </Select>
        </FormControl>
      </Grid>

    </Grid>

  );
}
